var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.795898,
    y: 0.392334,
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1136_17",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1136_17",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAABhElEQVRoge2YvU4CQRCAP5VEKIixER/GgkorfAV/3sDgz3MY3sTOWJGYqIU/lZ1iYqyNoQTF4jSOl729ZY8FbjNfQgKZY/YbWGaWA0VRFEVR4mEh9XoFWJyFiAdfwEdWsAeMSvLoSfGyfPq5RFNIxRLbBi6nJeLIBnBmCtgK6QPvQXT86WcFotlaWsi8I+fIM3AMVGdqlFADTkicjHMkjWkg3gONoJp21oEHg5e1kC7wAgxSb7rG3uFCUQFuUi6DH8euS4Iq0AaGIsFuCNMc9sX6Q+AAWPZJ1BGJzidlNwYXYv3TIom2RKLX4l5j8ybW37RdmNd+5TF/VFDKB+c18wppieePfi6FkGu2Mq+yUAMOgU/+vtqd4l5js8f/H3sbx7n2235ltxoBV8BSCNMcKiStX7oMcWi/poF4C6wFlM2jAdwZvJwn+xPJ9vLq2xOmChzheURphrbzoIn+Zy8J0RRiO9HWgdVpiThSzwrYCjHerZhXotla0RQS7U1sRVEURVHKzDdupp2jw5M06QAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.848ef3a1c99f00441765e3ba7ce9309b.svg";
export { ForwardRef as ReactComponent };